import { useTranslation } from 'translations/hooks';

import { ActivityTable } from 'business/shift-report/report/pages/ReportAggregated/components/activity-table';
import { TopAndSecondLevelCharts } from 'business/shift-report/report/pages/ReportAggregated/components/top-and-second-level-charts';
import { GetTopLevelCriticalTaskAggregateV1Response } from 'generated/apiSchemas';

interface ActivityAndGraphProps {
  startDate: string;
  endDate: string;
  criticalTasksAggregate:
    | GetTopLevelCriticalTaskAggregateV1Response
    | undefined;
  critical: boolean;
}

export default function ActivityTableAndGraphs({
  startDate,
  endDate,
  criticalTasksAggregate,
  critical,
}: Readonly<ActivityAndGraphProps>) {
  const { t } = useTranslation();

  return (
    <>
      <div key="activity-container" className="bloc">
        <h1>
          {t('pages.print.activityNotes', {
            context: critical ? 'critical' : '',
          })}
        </h1>
        <ActivityTable startDate={startDate} endDate={endDate} />
      </div>
      <TopAndSecondLevelCharts tasksAggregate={criticalTasksAggregate} />
    </>
  );
}
